import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Header from './Header/Header'
import Navbar from './Nav/Navbar'
import Footer from './Footer'
import Publisher from './FilterPages/Publishers'
import Categories from './FilterPages/Categories'
import Formats from './FilterPages/Formats'
import SupplyType from './FilterPages/SupplyType'
import Summary from './Summary'
import Results from './Results'
import axios from 'axios'
import { apiUrl } from '../consts/consts'

import categoryData from '../lookup_tables/categoryData.json'
import Dotnav from './Nav/Dotnav'

function MainPage({ user }) {
  const [publishers, setPublishers] = useState(null)
  const [categories, setCategories] = useState(null)
  const [formats, setFormats] = useState(null)
  const [checkedPublishers, setCheckedPublishers] = useState([])
  const [checkedCategories, setCheckedCategories] = useState([])
  const [checkedFormats, setCheckedFormats] = useState([])
  const [checkedSupplyTypes, setCheckedSupplyTypes] = useState([])
  const [resultStatus, setResultStatus] = useState(false)
  const [resultData, setResultData] = useState('')
  const [categoryLevel, setCategoryLevel] = useState('Top')
  const [hideZeroImpressions, setHideZeroImpressions] = useState(false)

  const navigate = useNavigate()
  let { filter } = useParams()

  const supplyTypes = [
    {
      id: 1,
      name: 'web',
      display_name: 'Web',
    },
    {
      id: 2,
      name: 'mobile_app',
      display_name: 'Mobile App',
    },
    {
      id: 3,
      name: 'mobile_web',
      display_name: 'Mobile Web',
    },
  ]

  useEffect(() => {
    if (!filter) {
      navigate('/publishers')
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function fetchData() {
    const token = localStorage.getItem('Impact')

    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    }

    try {
      const publishers = await axios.get(`${apiUrl}/publisher`, headers)
      // const categories = await axios.get(`${apiUrl}/category`, headers);
      const formats = await axios.get(`${apiUrl}/format`, headers)

      setPublishers(publishers.data)
      //Change back later
      setCategories(categoryData)

      formats.data.sort((a, b) => {
        const numA = parseInt(a.format.split('x')[0])
        const numB = parseInt(b.format.split('x')[0])
        return numA - numB
      })

      setFormats(formats.data)
    } catch (error) {}
  }

  function handleSignOut(e) {
    e.preventDefault()
    localStorage.removeItem('Impact')
    navigate('/login')
  }

  return (
    <>
      <div className="wrapper">
        <Header />
        <div className="user-info">
          <div className="user-info-txt">
            <ul>
              <li>
                <h3>
                  {user?.firstName} {user?.lastName}
                </h3>
              </li>
              <li>
                <a
                  href="/login"
                  onClick={(e) => {
                    handleSignOut(e)
                  }}>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="container">
          <Navbar />
          {filter === 'publishers' && publishers && (
            <Publisher
              checkedPublishers={checkedPublishers}
              setCheckedPublishers={setCheckedPublishers}
              publishers={publishers}
            />
          )}
          {filter === 'categories' && (
            <Categories
              checkedCategories={checkedCategories}
              setCheckedCategories={setCheckedCategories}
              categories={categories}
              categoryLevel={categoryLevel}
              user={user}
            />
          )}
          {filter === 'formats' && (
            <Formats checkedFormats={checkedFormats} setCheckedFormats={setCheckedFormats} formats={formats} />
          )}
          {filter === 'supplytype' && (
            <SupplyType
              checkedSupplyTypes={checkedSupplyTypes}
              setCheckedSupplyTypes={setCheckedSupplyTypes}
              supplyTypes={supplyTypes}
            />
          )}
        </div>
        <Results
          resultStatus={resultStatus}
          setResultStatus={setResultStatus}
          resultData={resultData}
          hideZeroImpressions={hideZeroImpressions}
        />
        <Summary
          checkedPublishers={checkedPublishers}
          checkedCategories={checkedCategories}
          checkedFormats={checkedFormats}
          checkedSupplyTypes={checkedSupplyTypes}
          setCheckedPublishers={setCheckedPublishers}
          setCheckedCategories={setCheckedCategories}
          setCheckedFormats={setCheckedFormats}
          setCheckedSupplyTypes={setCheckedSupplyTypes}
          setResultStatus={setResultStatus}
          setResultData={setResultData}
          user={user}
          hideZeroImpressions={hideZeroImpressions}
          setHideZeroImpressions={setHideZeroImpressions}
        />
        <Dotnav setCategoryLevel={setCategoryLevel} categoryLevel={categoryLevel} user={user} />
        <Footer />
      </div>
    </>
  )
}

export default MainPage
